export default __webpack_public_path__ + "static/media/2.4d8870f7.jpg";